<!-- 
    描述：审计公共弹窗
    时间： 2021/03/31
    Created by zl
-->
<template>
	<div>
		<template v-if="dialogType == 'deal'  || 
				  dialogType == 'del' || 
				  dialogType == 'recall' || 
				  dialogType == 'details'">
			<el-row :gutter="10">
				<el-form ref="form"
						 :model="dataObj"
						 label-width="120px">
					<el-col :span="12">
						<el-form-item label="工程项目名称：">
							<div class="text-overflow">
								<TextTooltip :content="dataObj.proName"
											 :refName="'dataObjProName'"></TextTooltip>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="标段名称：">
							<div class="text-overflow">
								<TextTooltip :content="dataObj.packName"
											 :refName="'dataObjPackName'"></TextTooltip>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="委托单位：">
							{{ dataObj.sponsorUnit }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="委托单位类型：">
							<span v-if="dataObj.entrustType == 0">建设单位</span>
							<span v-else-if="dataObj.entrustType == 1">审计单位</span>
							<span v-else>-</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="委托日期：">
							{{ dataObj.taskEntrustDate }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="审计任务类型：">
							{{ dataObj.auditTypeName }}
						</el-form-item>
					</el-col>
					<el-col :span="24"
							v-if="dialogType == 'deal' && routeName == 'AuditTask' && dataObj.entrustType">
						<el-form-item label="附件：">
							<span v-for="item in fileList"
								  :key="item.id"
								  class="mr10">
								<FileName :fileName="item.fileName"
										  :filePath="item.filePath"
										  :fileSize="item.fileSize"></FileName>
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="24"
							v-if="dialogType == 'deal' && routeName == 'AuditTask' && dataObj.entrustType">
						<el-form-item label="备注：">
							{{ dataObj.remark }}
						</el-form-item>
					</el-col>
					<el-col :span="12"
							v-if="dialogType == 'details'">
						<el-form-item label="退审人员：">
							{{ dataObj.updateUserName }}
						</el-form-item>
					</el-col>
					<el-col :span="12"
							v-if="dialogType == 'details'">
						<el-form-item label="退审时间：">
							{{ dataObj.updateDate }}
						</el-form-item>
					</el-col>
					<el-col v-if="dialogType == 'deal'"
							:span="24"
							class="mt20">
						<p class="tips">
							<i class="el-icon-warning"></i>
							温馨提示：确认受理后，该委托任务会在待受理项目列表中消失，在已受理项目列表中新增一条已受理项目。
						</p>
					</el-col>
					<el-col v-if="dialogType != 'deal'"
							:span="24">
						<el-form-item v-if="dialogType == 'recall' || dialogType == 'del'"
									  :label="dialogType == 'recall' ? '填写撤回原因：' : '退审原因：'"
									  :rules="requiredRule">
							<el-input type="textarea"
									  :autosize="{ minRows: 4 }"
									  placeholder="请填写内容"
									  :disabled="dialogType == 'details'"
									  maxlength="200"
									  show-word-limit
									  v-model="comeBackReason"></el-input>
						</el-form-item>
						<el-form-item label="退审原因："
									  v-else>
							{{ comeBackReason }}
						</el-form-item>
					</el-col>
					<el-col v-if="dialogType == 'del'"
							:span="24"
							class="mt5">
						<p class="tips">
							<i class="el-icon-warning"></i>
							温馨提示：确认退审后，该委托任务会在待受理项目列表中消失，在退审项目列表中新增一条退审项目。
						</p>
					</el-col>
					<el-col v-if="dialogType == 'recall'"
							:span="24"
							class="mt5">
						<p class="tips">
							<i class="el-icon-warning"></i>
							温馨提示：确认撤回后，该委托任务会在业主委托协审项目列表中消失，在退审项目列表中新增一条退审项目。
							建设单位会收到一条驳回信息。
						</p>
					</el-col>
				</el-form>
			</el-row>
		</template>
		<template v-if="dialogType == 'addPerson' || dialogType == 'editPerson'">
			<el-form ref="addForm"
					 :model="addForm"
					 label-width="160px">
				<el-row>
					<template v-if="dialogType == 'addPerson'">
						<el-col :span="22"
								v-if="onlyshow">
							<el-form-item label-width="85px">
								<span class="red">*</span>
								标段已受理成功，请在<span class="blue">已受理</span>列表中进行查看。可继续为该标段添加
								{{ this.routeName == 'AuditTask' ? '协审单位项目负责人' : '审计机关主审' }}
							</el-form-item>
						</el-col>
						<el-col :span="22"
								:offset="1">
							<el-form-item label="工程项目名称">
								<el-input v-model="addForm.proName"
										  disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="22"
								:offset="1">
							<el-form-item label="标段名称">
								<el-input v-model="addForm.packName"
										  disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="22"
								:offset="1">
							<el-form-item label="审计任务类型">
								<el-input v-model="addForm.taskTypeName"
										  disabled></el-input>
							</el-form-item>
						</el-col>
					</template>
					<div v-if="dialogType == 'editPerson'"
						 class="personDetail">
						<el-col :span="22"
								:offset="1">
							<el-form-item label="工程项目名称：">
								{{ addForm.proName }}
							</el-form-item>
						</el-col>
						<el-col :span="11"
								:offset="1">
							<el-form-item label="标段名称：">
								{{ addForm.packName }}
							</el-form-item>
						</el-col>
						<el-col :span="11"
								:offset="1">
							<el-form-item label="审计任务类型：">
								{{ addForm.taskTypeName }}
							</el-form-item>
						</el-col>
						<el-col :span="11"
								:offset="1">
							<el-form-item :label="this.routeName == 'AuditTask' ? '协审单位项目负责人：' : '审计机关主审：'">
								{{ addForm.taskPrincipalName }}
							</el-form-item>
						</el-col>
						<el-col :span="11"
								:offset="1">
							<el-form-item :label="this.routeName == 'AuditTask' ? '负责人联系方式：' : '主审人联系方式：'">
								{{ addForm.constractCopy }}
							</el-form-item>
						</el-col>
						<el-col :span="22"
								:offset="1">
							<el-form-item label="职务描述：">
								{{ addForm.descriptionCopy }}
							</el-form-item>
						</el-col>
					</div>
					<div class="green"
						 v-if="dialogType == 'editPerson'">
						<span>{{ this.routeName == 'AuditTask' ? '更改负责人' : '更改主审人' }}</span>
					</div>
					<el-col :span="22"
							:offset="1">
						<el-form-item :label="this.routeName == 'AuditTask' ? '协审单位项目负责人' : '审计机关主审'"
									  :rules="requiredRule"
									  prop="taskPrincipal">
							<el-select v-model="addForm.taskPrincipal"
									   :placeholder="this.routeName == 'AuditTask' ? '请选择协审单位项目负责人' : '请选择审计机关主审'"
									   @change="personChange"
									   filterable>
								<el-option v-for="item in personList"
										   :key="item.userId"
										   :label="item.sname"
										   :value="item.userId">
								</el-option>
							</el-select>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="22"
							:offset="1">
						<el-form-item :label="this.routeName == 'AuditTask' ?  '负责人联系方式' : '主审人联系方式'"
									  :rules="requiredRule"
									  prop="constract">
							<el-input v-model="addForm.constract"
									  placeholder="请填写负责人联系方式"
									  disabled
									  @blur="phoneCheck(addForm.constract)"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="22"
							:offset="1">
						<el-form-item label="职务描述">
							<el-input v-model="addForm.description"
									  type="textarea"
									  :autosize="{ minRows: 7 }"
									  maxlength="200"
									  show-word-limit
									  placeholder="请填写职务描述"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</template>
		<template v-if="dialogType == 'entrust'">
			<el-form ref="personForm"
					 :model="entrustForm"
					 label-width="140px">
				<el-row>
					<el-col :span="22"
							:offset="1">
						<el-form-item label="工程项目名称">
							<el-input v-model="entrustForm.proName"
									  disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="22"
							:offset="1">
						<el-form-item label="标段名称">
							<el-input v-model="entrustForm.packName"
									  disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="22"
							:offset="1">
						<el-form-item label="审计任务类型">
							<el-select v-model="entrustForm.auditType"
									   disabled>
								<el-option v-for="(item, index) in projectDict.sjrwlx"
										   :key="'auditType' + index"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="22"
							:offset="1">
						<el-form-item label="委托协审单位"
									  :rules="changeRule"
									  prop="assitantUnit">
							<el-select v-model="entrustForm.assitantUnit"
									   placeholder="请选择委托协审单位"
									   filterable>
								<el-option v-for="item in UnitsList"
										   :key="item.value"
										   :label="item.sname"
										   :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="22"
							:offset="1">
						<el-form-item label="协审单位确定方式"
									  :rules="changeRule"
									  prop="confirmType">
							<el-select v-model="entrustForm.confirmType"
									   placeholder="请选择协审单位确定方式">
								<el-option v-for="(item,index) in projectDict.qrfs"
										   :key="'confirmType' + index"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="22"
							:offset="1">
						<el-form-item label="附件">
							<myUpload v-if="this.dataObj.id"
									  ref="fileUpload"
									  tableName="bus_task"
									  assortment='test'
									  listType="text"
									  width="200px"
									  height="110px"
									  :createCompany="upUnit"
									  :shortName="shortName"
									  :aid="this.dataObj.id"
									  uploadType="4"></myUpload>
						</el-form-item>
					</el-col>
					<el-col :span="22"
							:offset="1">
						<el-form-item label="备注">
							<el-input v-model="entrustForm.remark"
									  type="textarea"
									  :autosize="{ minRows: 7 }"
									  maxlength="200"
									  show-word-limit
									  placeholder="请填写内容"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</template>
	</div>
</template>
<script>
import { selectentrustUnits } from 'api/projectManage/ProjectIndex'
import { mapState } from 'vuex'
import { getUserTenantTablePageListByTenantId } from 'api/system/sysUserTenant'
import TextTooltip from '@/views/Common/TextTooltip'
import * as Api from 'api/projectManage/ProjectIndex'
import { getFiles } from 'api/upload/upload'
import FileName from '@/components/file/fileName'
export default {
	name: 'AuditDialog',
	props: {
		dialogType: {
			type: String,
			default: '',
		},
		dataObj: {
			type: Object,
			default: () => ({}),
		},
		onlyshow: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		TextTooltip,
		FileName,
	},
	data() {
		return {
			requiredRule: [{ required: true, message: '不能为空...' }],
			changeRule: [
				{
					required: true,
					message: '不能为空...',
					trigger: 'change',
				},
			],
			testOptions: [
				{
					label: '选项一',
					value: '1',
				},
			],
			comeBackReason: '', //撤回原因
			// 添加负责人
			addForm: {
				proName: this.dataObj.proName, //工程项目名称
				packName: this.dataObj.packName, //标段名称
				taskTypeName: this.dataObj.auditTypeName, //审计任务类型
				oldTaskPrincipal: '', //上一步审计单位负责人
				taskPrincipal: '', //审计单位负责人
				constract: '', //负责人联系方式
				description: '', //负责人职位描述
			},
			// 委托协审
			entrustForm: {
				proName: this.dataObj.proName, //工程项目名称
				packName: this.dataObj.packName, //标段名称
				auditType: this.dataObj.auditType, //审计任务类型
				confirmType: this.dataObj.confirmType, //协审单位确定方式
				assitantUnit: this.dataObj.assitantUnit, //委托协审单位
				remark: this.dataObj.remark,
			},
			UnitsList: [], //委托协审单位
			personList: [], //单位联系人
			fileList: [], //附件列表
			upUnit: '', //上传单位
			shortName: '', //简称
		}
	},
	created() {
		// 委托协审
		if (this.dialogType == 'entrust') {
			this.getUnits()
			this.getCompanyMsg()
		} else if (this.dialogType == 'details') {
			this.comeBackReason = this.dataObj.reason
		} else if (
			this.dialogType == 'addPerson' ||
			this.dialogType == 'editPerson'
		) {
			this.getPerson()
			if (!!this.dataObj.taskPrincipal) {
				this.addForm.oldTaskPrincipal = this.dataObj.taskPrincipal
			}
			if (this.dialogType == 'editPerson') {
				this.addForm.taskPrincipalName = this.dataObj.taskPrincipalName
				this.addForm.constractCopy = this.dataObj.constract
				this.addForm.descriptionCopy = this.dataObj.description
			}
		}

		if (
			this.dialogType == 'deal' &&
			this.routeName == 'AuditTask' &&
			this.dataObj.entrustType
		) {
			getFiles({
				aid: this.dataObj.pid,
				tableName: 'bus_task',
				assortment: 'test',
				source: '0',
				type: '4',
			})
				.then((res) => {
					this.fileList = res.data
				})
				.catch(() => {
					this.fileList = []
				})
		}
	},
	methods: {
		// 获取委托协审单位
		getUnits() {
			let params = {
				limitId: '1382233569480044661',
			}
			selectentrustUnits(params).then((res) => {
				this.UnitsList = res.data
			})
		},

		// 获取当前登录人公司信息
		getCompanyMsg() {
			Api.selectTenantInformation({
				tenantId: this.$getSessionItem('tenantId'),
			}).then((res) => {
				this.upUnit = res.data.unitName
				this.shortName = res.data.shortName
			})
		},

		// 联系方式校验
		phoneCheck(data) {
			if (data.length > 0) {
				let isPhone = /^1[3-9][0-9]{9}$/ //手机号码
				let isMob = /^[0][1-9]{2,3}-[0-9]{5,10}$/ // 座机格式  区号之后用'-'隔开
				if (isMob.test(data) || isPhone.test(data)) {
					return true
				} else {
					this.$message.error('格式不正确，请输入手机号码或者座机号')
					this.addForm.constract = ''
					return false
				}
			}
		},

		// 获取单位负责人
		getPerson() {
			getUserTenantTablePageListByTenantId({
				tenantId: this.dataObj.tenantId,
				current: 1,
				size: 1000,
			}).then((res) => {
				this.personList = res.data.records
			})
		},

		// 更换负责人
		personChange(data) {
			let obj = this.personList.find((x) => x.userId == data)
			if (obj) {
				this.addForm.constract = obj.phone
			}
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
		...mapState('user', {
			tenantId: (state) => state.tenantId,
		}),
		routeName() {
			return this.$route.name
		},
	},
}
</script>
<style lang='less' scoped>
.tips {
	padding: 5px 10px;
	background-color: rgba(96, 173, 249, 0.3);
	border: 1px solid #60adf9;
	color: #2f93f8;
	font-size: 13px;
}
.red {
	color: red;
}
.red {
	color: #60adf9;
}
.personDetail {
	.el-form-item {
		margin-bottom: 0px !important;
	}
}
.green {
	span {
		display: inline-block;
		padding: 0 15px !important;
		background-color: #ccc;
		color: #fff;
		font-size: 14px;
		font-weight: bold;
		height: 32px;
		line-height: 32px;
	}
	border-bottom: 1px solid #eee;
	width: 90%;
	margin: 15px auto;
}
</style>
